import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TextField, InputAdornment, Button } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import OtpInput from "../OtpInput";
import useApi from "../../hooks/useApi";
import { isValidEmail } from "../../utils/helpers";

export const EmailInput = ({
  name = "email",
  email,
  label,
  type = "email",
  autoComplete = "email",
  onChange,
  onFocus,
  onBlur,
  required = false,
  hasError = false,
  showStatusIcon = false,
  needsVerification = false,
  setEmailNeedsVerification,
  size = "small",
  errorText = "",
  helperText = "",
  ...props
}) => {
  const { t } = useTranslation();
  const { post } = useApi();
  const [error, setError] = useState("");
  const [verifiedEmail, setVerifiedEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otpHasError, setOtpHasError] = useState(false);

  // const [resendTimer, setResendTimer] = useState(0);
  // const [canResend, setCanResend] = useState(true);

  // const startResendTimer = () => {
  //   setResendTimer(60);
  //   setCanResend(false);
  // };

  // useEffect(() => {
  //   if (showStatusIcon) {
  //     let interval;
  //     if (resendTimer > 0) {
  //       interval = setInterval(() => {
  //         setResendTimer((prev) => {
  //           if (prev === 1) {
  //             setCanResend(true);
  //             return 0;
  //           }
  //           return prev - 1;
  //         });
  //       }, 1000);
  //     }
  //     return () => clearInterval(interval);
  //   }
  // }, [resendTimer, showStatusIcon]);

  const handleChange = (e) => {
    setShowOtpInput(false);
    setOtp("");
    setOtpHasError(false);

    if (onChange) onChange(e);
  };

  const handleFocus = (e) => {
    setError(false);

    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e) => {
    const { value } = e.target;
    if (!value && required) {
      setError(t("error_email_required"));
    } else if (!isValidEmail(value)) {
      setError(t("error_email_format"));
    }

    if (onBlur) {
      onBlur(e);
    }
  };

  const sendOTP = async () => {
    setShowOtpInput(true);

    try {
      await post("/Otp/create", {
        email,
      });
    } catch (err) {
      console.error("otp send filed:", err);
    }
  };

  const validateOtp = async () => {
    try {
      const resp = await post("/Otp/validate", {
        email,
        code: otp,
      });

      if (resp.isValid) {
        setVerifiedEmail(email);
        setShowOtpInput(false);
        setError("");

        if (setEmailNeedsVerification) setEmailNeedsVerification(false);
      } else {
        setOtpHasError(true);
      }
    } catch (err) {
      console.error("otp validation filed:", err);
    }
  };

  return (
    <>
      <TextField
        fullWidth
        id="email-input"
        variant="outlined"
        margin="normal"
        type="email"
        size={size}
        name={name}
        value={email}
        label={label || t("input_label_email")}
        error={hasError || !!error}
        helperText={error || errorText || helperText}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <MailOutlineIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment
                position="end"
                sx={{
                  display:
                    showStatusIcon && isValidEmail(email) ? "inherit" : "none",
                }}
              >
                {verifiedEmail === email || !needsVerification ? (
                  <CheckCircleIcon color="success" />
                ) : (
                  <Button
                    variant="text"
                    sx={{
                      minWidth: "36px",
                      padding: 0,
                      textTransform: "none",
                    }}
                    onClick={sendOTP}
                    disabled={showOtpInput}
                  >
                    {t("verify")}
                  </Button>
                )}
              </InputAdornment>
            ),
          },
        }}
        {...props}
      />
      {showOtpInput && needsVerification && (
        <OtpInput
          otp={otp}
          otpHasError={otpHasError}
          setOtp={setOtp}
          setOtpHasError={setOtpHasError}
          validateOtp={validateOtp}
        />
      )}
    </>
  );
};
